import cloudbase from '@cloudbase/js-sdk';
window.cloudbase = cloudbase;
